export default __webpack_public_path__ + "static/1734255904-64912793-573x501x573x501x0x0-jl-blueshirt-patch-ec3996341c3bf489886e09385a25f879.webp";